<template>

	<div class="main-contents">
		<div class="mem_container">
			<div class="mem_info_contents">
				<div class="mem_contents_header">
					<div class="title-txt">마이페이지<br/>
						<p><span class="prj_ct"><nbsp n="1"/><span>{{data.mberNm}}</span> 님 반갑습니다.</span></p>
					</div>
				</div>
				<div class="contents-body tab point sco">
					<div class="my-resume">
						<div class="photo">
							<file-select type="image" v-model="data.imgFile" :src="data.imgSrc" defaultSrc="COMPANY" :name="data.corpNm" @change="corpImgAttach"/>
							기업 대표 이미지로 첨부 바랍니다.<br/>이미지 미첨부시 기본이미지로 저장됩니다.
						</div>

						<div class="mem-box">
							<div class="mem-count">
								<div class="mem">소속 IT프로</div>
								<div class="count">{{asgApprMberCnt.asgMberCnt | number}}명</div>
							</div>
							<div class="mem-count">
								<div class="mem">소속 승인요청</div>
								<div class="count">{{asgApprMberCnt.asgApprMberCnt | number}}명</div>
								<span class="noti" v-if="asgApprMberCnt.asgApprMberCnt > 0">!</span>
							</div>
							<div class="mem-count">
								<div class="mem">소속 퇴사요청</div>
								<div class="count">{{asgApprMberCnt.asgResignMberCnt | number}}명</div>
								<span class="noti" v-if="asgApprMberCnt.asgResignMberCnt > 0">!</span>
							</div>
						</div>
					</div>
				</div>

				<div class="contents-body tab point sco2">
                        <div class="my-resume"> 

                            <div class="mem-box">
                                <div class="title">프로젝트</div>
                                <div class="mem-count">
                                    <div class="mem">지원 IT프로</div><div class="count">{{scoPrjCnt.genProjectApplyCnt | number}}명</div>
                                    <span class="noti" v-if="scoPrjCnt.genProjectApplyCnt > 0">!</span>
									<div class="shortcut" @click="$router.push({name: 'PRJ403M01'})">바로가기 &#9654;</div>
                                </div>
                            </div>
							
                            <div class="mem-box last">
                                <div class="title"> </div>
                                <div class="mem-count">
                                    <div class="mem">참여예정</div><div class="count">{{scoPrjCnt.genProjectBeforeCnt | number}}명</div>
                                    <span class="noti" v-if="scoPrjCnt.genProjectBeforeCnt > 0">!</span>
                                    <div class="shortcut" @click="movePage('prj','03')">바로가기 &#9654;</div>
                                </div>
                                <div class="mem-count">
                                    <div class="mem">참여중</div><div class="count">{{scoPrjCnt.genProjectIngCnt | number}}명</div>
                                    <span class="noti" v-if="scoPrjCnt.genProjectIngCnt > 0">!</span>
                                    <div class="shortcut" @click="movePage('prj','04')">바로가기 &#9654;</div>
                                </div>
                            </div>

                        </div>
                    </div>

					<!-- 프로젝트 인터뷰 요청 상태 -->
                    <div class="contents-body prj dco mt-0" style="border: 1px solid #808285; margin-bottom: 35px !important;">
                        <div class="title">
                            인터뷰 요청 상태
                        </div>

						<template v-if="prjIntvList && prjIntvList.length > 0">
							<template v-for="(item, idx) in prjIntvList">
								<hr v-if="idx != 0" :key="'hr_' + idx"/>
								<div class="prj-box" :key="'project_' + idx">{{item.projectNm}}</div>
								<div class="member" :key="'total_' + idx">
									<p>인터뷰 요청 IT프로</p>
									<span class="count">총 {{item.interviewTotalCnt | number}}명</span>
								</div>
								<div class="member" :key="'detail_' + idx">
									<p>인터뷰 예정</p>
									<span class="count">{{item.interview01Cnt + item.interview02Cnt | number}}명</span>
									/ 
									<p>인터뷰 합격</p>
									<span class="count">{{item.interview04Cnt | number}}명</span>
									/ 
									<p>인터뷰 불합격</p>
									<span class="count">{{item.interview03Cnt | number}}명</span>
									<div class="shortcut" @click="movePage('intv',item)">바로가기 &#9654;</div>
								</div>
							</template>
						</template>
						<template v-else>
							<div class="prj-box">인터뷰 중인 프로젝트가 없습니다.</div>
						</template>
                    </div>

					<!--IT프로 승인관리-->
					<div class="contents-body prj mypage mt-0" style="margin-bottom: 35px !important;">
						<div class="title"><img src="/images/people_ico.png" alt="프로젝트현황아이콘"/>{{data.corpNm}} 소속 IT프로 승인관리</div>
						<div class="filter">
							<div class="search_box">
								<div style="
									display: inline-flex;
									align-items: center;
									position: relative;
									padding: 2px 15px;
									border: 1px solid #D6D7D8;
									border-radius: 25px;
									background: #fff;
								">
									<input type="text" class="search_box int" placeholder="회원명" v-model="srcFilter.srcTxt" @keyup.enter="selectAsgMberAppList('1')"> 
									<div class="search_btn">
										<img class="search" src="/images/icon_srch.png" alt="검색버튼" @click="selectAsgMberAppList('1')"/>
									</div>
								</div>
							</div>
							<div class="filter_box prj_list">
								<ul>
									<li><img :class="srcFilter.ordCol == 'REG_DATE' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="searchOrder('REG_DATE')">요청일 순</p><span>ㅣ</span></li>
									<li><img :class="srcFilter.ordCol == 'EMP_DIV_CD' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="searchOrder('EMP_DIV_CD')">직원구분 순</p></li>
								</ul>
								<div class="state">
									승인상태
									<label for="00"><input type="checkbox" name="state" id="00" v-model="srcFilter.srcApprYn" @change="selectAsgMberAppList('1')">미승인</label>
								</div>
							</div>
						</div>
						<!-- 소속 승인 요청 IT프로 리스트 -->
						<div class="Board type3">
							<table class="Board_type3 demand">
								<colgroup>
									<col width="4%">
                                    <col width="13%">
                                    <col width="6%">
                                    <col width="8%">
                                    <col width="60">
                                    <col width="9%">
								</colgroup>
								<thead>
									<tr>
										<th>NO</th>
										<th>회원명</th>
										<th>성별</th>
										<th>직원구분</th>
										<th>소속</th>
										<th>승인요청일</th>
									</tr>
								</thead>
								<tbody v-if="asgMberAppList.length > 0">
									<!-- 최대 10건 조회 -->
									<tr v-for="(row, index) in asgMberAppList" :key="index">
										<td class="score"><div v-if="row.corpApprDiv != '04'" class="flag">미승인</div>{{ (pageInfo.pageIndex - 1) * pageInfo.pageSize + (index + 1)}}</td>
										<td class="score btn_cursor" @click="openPop(row.mberSeq)">{{row.mberNm}} &#9654;</td>
										<td class="score"><SelectComp type="text" list="F:여,M:남" v-model="row.gender" /></td>
										<td class="score">
											<span v-if="row.empDivCd =='' || row.empDivCd == null">-</span>
											<span v-else><SelectComp type="text" cdId="PRO102" v-model="row.empDivCd" /></span>
										</td>
										<td :class="row.corpApprDiv == '01' || row.corpApprDiv == '02'? 'score btn':'score'">
											<span v-if="row.corpApprDiv == '01'"><div class="btn_approve" @click="mberAppr(index)">소속 승인요청</div></span>
											<span v-else-if="row.corpApprDiv == '02'"><div class="btn_withdrawal" @click="mberAppr(index)">소속 탈퇴요청</div></span>
											<span v-else>{{row.corpNm}}</span>
										</td>
										<td class="score">
											{{row.regDate}}
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<!-- 소속 승인 요청 IT프로가 없을 경우 -->
									<tr>
										<td colspan="6" class="none">소속 승인 요청 IT프로가 없습니다.</td>
									</tr>
								</tbody>
							</table>
						</div>

						<!-- 페이징부분 -->
						<pagingComp :pageInfo="pageInfo" @page-click="goPage"/>
					</div>
			</div>
		</div>
	</div>
</template>

<script>

import fileSelect from "@/components/FileSelect.vue";
import Nbsp from '../../../components/base/nbsp.vue';
import pagingComp from '@/components/PagingComp.vue';

export default {

	components : { fileSelect, Nbsp, pagingComp },

	data() {
		return {
			data: {
				corpSeq :''
			},

			asgApprMberCnt : {},
			scoPrjCnt : {},
			prjIntvList : [],
			corpdiv : this.$store.state.userInfo.mberDivCd,

			// 소속 IT프로 승인관리 리스트
			asgMberAppList : [],
			pageInfo : {},
			srcFilter : {
				pageIndex : '1',
				ordCol : 'REG_DATE',
				srcTxt : '',
				srcApprYn : ''
			},
		};
	},
	mounted(){
		this.$.httpPost('/api/mem/myp/getScoCorpInfo')
			.then(res => {
				this.data = res.data.scoCorpInfo;
				this.scoPrjCnt = res.data.scoPrjCnt;
				this.asgApprMberCnt = res.data.asgApprMberCnt;
				this.data.imgSrc = '/api/mem/myp/corpImageDown?corpSeq=' + this.data.corpSeq;

				this.data.corpSeq = res.data.scoCorpInfo.corpSeq;

				this.selectAsgMberAppList();
			});

		this.$.httpPost('/api/prj/prj/getInterviewProject', {corpdiv : this.corpdiv})
			.then(res => {
				this.prjIntvList = res.data.list;
			});	
	},

	methods: {
		// 기업 이미지 첨부
		corpImgAttach() {
			if(this.data.imgFile) {
				this.$.fileUpload('IMG', this.data.imgFile, '/api/mem/myp/corpImageAttachment', this.data)
					.then(() => {
						this.data.imgFile = null;
						this.data.imgSrc = '/api/mem/myp/corpImageDown?corpSeq=' + this.data.corpSeq;
					});
			}
		},

		movePage(div,item) {
			var params = {}
			if(div == 'intv'){
				params.projectSeq = item.projectSeq;
				params.projectNm = item.projectNm;
				params.caller = { name: this.$route.name};
			
				this.$router.push({name: 'PRJ404M02', params });
			}else{
				var projectRecrStatus = '2'
				if(item == '04'){ projectRecrStatus = '1' }
	
				params.projectRecrStatus = projectRecrStatus;
				params.caller = { name: this.$route.name }

				this.$router.push({name: 'PRJ401M01', params });
			}
        },

		// IT프로 승인 리스트
		selectAsgMberAppList(div){
			var param = this.srcFilter;
			param.corpSeq = this.data.corpSeq;
			param.pageUnit = '10';
			param.pageSize = '10';
			if(div) param.pageIndex = 1;

			this.$.httpPost('/api/mem/myp/selectAsgMberAppList', param)
			.then(res => {
				this.asgMberAppList = res.data.asgMberAppList;
				this.pageInfo = res.data.pageInfo;
			});

		},

		// 소속 승인관련 IT프로 수
		selectAsgApprMberCnt(){
			this.$.httpPost('/api/mem/myp/selectAsgApprMberCnt', {corpSeq : this.data.corpSeq})
			.then(res => {
				this.asgApprMberCnt = res.data;
			});
		},

		// IT프로 소속 승인하기
		mberAppr(index) {
			var obj = this.asgMberAppList[index];

			var params = {
				mberNm:obj.mberNm,
				gender:obj.gender,
				empDivCd:obj.empDivCd,

				classDivCd : obj.classDivCd,
				corpApprDivCd  : obj.corpApprDiv,
				aftEmpDivCd : obj.aftEmpDivCd,
				aftCorpNm : obj.aftCorpNm || '소속없음',
			};

			this.$.popup('/sco/myp/MYP401P01', params)
				.then(res => {
					if(res.flag) {
						var param = {
							apprMberSeq : obj.mberSeq,
							empDivCd:obj.empDivCd,

							mberAsgHistorySeq :obj.mberAsgHistorySeq,
							classDivCd : obj.classDivCd,
							aftEmpDivCd : obj.aftEmpDivCd,
							aftCorpSeq : obj.aftCorpSeq, 
							aftCorpNm : obj.aftCorpNm || '소속없음',
						};

						param.aftAsgApprYn = res.apprYn;
					
						this.$.httpPost('/api/mem/myp/updateAsgMberAppInfo', param)
							.then(() => {
								this.selectAsgMberAppList();
								this.selectAsgApprMberCnt();
							}).catch(this.$.httpErrorCommon);
					}
				})
		},
		// IT프로 개인정보 팝업
		openPop(seq) {
			var div = 'tec';
			this.$.popup('/dco/pmg/myp/MYP301P01', { seq, div });
		},

		// sort 변경
		searchOrder(col) {
			this.srcFilter.ordCol = col;
			this.selectAsgMberAppList();
		},

		// IT프로 승인관리 페이징 이동
		goPage(page) {
			this.srcFilter.pageIndex = page;
			this.selectAsgMberAppList();
		},
	},
};
</script>
